export { default } from "./popover-info-icon";
